import { Flex } from '@/components/priority/Flex/Flex'
import { PdfViewerSkeleton } from '@/components/pdfRender/PdfViewerSkeleton'
import { PdfProofGallery } from '@/components/pdfRender/PdfProofGallery'
import { useTranslation } from 'react-i18next'
import { PdfStatusKey } from '@messenger/types'
import type { ProofGalleryDetails } from '@/hooks/pdf/usePdfViewer'

type PdfViewerContentProps = {
  isProof: boolean
  pdfUrl: string
  pdfGenerationProgress: number
  pdfGenerationStatus: PdfStatusKey
  proofGalleryDetails?: ProofGalleryDetails | null
}

export const PdfViewerContent = ({
  isProof,
  pdfUrl,
  pdfGenerationProgress,
  pdfGenerationStatus,
  proofGalleryDetails,
}: PdfViewerContentProps) => {
  const { t } = useTranslation()
  const iframeTitle = isProof ? t('pdf.proofPreview') : t('pdf.productionProof')
  const proofScreenshots = proofGalleryDetails?.screenshotUrls ?? []
  const shouldShowProofGallery = isProof && proofScreenshots.length > 0

  return (
    <Flex
      width="100%"
      flex="1"
      role="region"
      aria-label={t('pdf.pdfContentRegionAriaLabel')}
    >
      {shouldShowProofGallery ? (
        <PdfProofGallery
          key={proofGalleryDetails?.pdfId ?? proofScreenshots[0]}
          screenshotUrls={proofScreenshots}
        />
      ) : pdfUrl ? (
        <iframe
          src={pdfUrl}
          width="100%"
          height="100%"
          style={{ border: 'none' }}
          title={iframeTitle}
          aria-label={t('pdf.pdfViewerAriaLabel')}
          role="document"
        />
      ) : (
        <PdfViewerSkeleton
          pdfGenerationProgress={pdfGenerationProgress}
          pdfGenerationStatus={pdfGenerationStatus}
          isProof={isProof}
        />
      )}
    </Flex>
  )
}
